if (!customElements.get('testimonial-slider')) {
  customElements.define(
    'testimonial-slider',
    class TestimonialSlider extends HTMLElement {
      connectedCallback() {
        this.sliderElement = this.querySelector('.splide');
        if (!this.sliderElement) return;

        if (window.Splide) {
          this.mountSplide();
        } else {
          // Splide loads with `defer` from a CDN; if this runs first, wait for it.
          window.addEventListener('load', () => this.mountSplide(), { once: true });
        }

        // In the theme editor, jump to a testimonial when it is selected.
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.tsl__slide');
          const slides = Array.from(this.querySelectorAll('.tsl__slide:not(.splide__slide--clone)'));
          const index = slides.indexOf(slide);
          if (this.splide && index > -1) this.splide.go(index);
        });
      }

      disconnectedCallback() {
        if (this.splide) this.splide.destroy();
      }

      mountSplide() {
        if (!window.Splide || this.splide || !this.sliderElement) return;

        const data = this.dataset;
        const number = (value, fallback) => parseInt(value, 10) || fallback;
        const type = data.type || 'slide';
        const perPage = type === 'fade' ? 1 : number(data.perPage, 1);
        const perPageMobile = type === 'fade' ? 1 : number(data.perPageMobile, 1);

        this.splide = new window.Splide(this.sliderElement, {
          type,
          perPage,
          rewind: type === 'slide',
          gap: `${number(data.gap, 0)}px`,
          speed: number(data.speed, 600),
          drag: data.drag === 'true',
          arrows: data.arrows === 'true',
          pagination: data.pagination === 'true',
          autoplay: data.autoplay === 'true',
          interval: number(data.interval, 5000),
          pauseOnHover: data.pauseOnHover === 'true',
          breakpoints: { 749: { perPage: perPageMobile } },
        });
        this.splide.mount();
      }
    }
  );
}
